<template>
  <div class="container">
    <form @submit.prevent="submitForm">
      <div class="row">
        <div class="col">
          <div class="input-group mb-3">
            <span class="input-group-text" id="basic-company">Company:<span class="custom-astrisk">*</span></span>
            <input
              v-model="form.company"
              type="text"
              class="form-control"
              placeholder="Company"
              aria-label="Company"
              aria-describedby="basic-company"
              @keyup="changed"
            />
            <span v-if="!v$.company.required" class="text-danger">Company is required</span>
          </div>
        </div>
        <div class="col">
          <div class="input-group mb-3">
            <span class="input-group-text" id="basic-addressLines">Address:<span class="custom-astrisk">*</span></span>
            <textarea
              v-model="form.addressLines"
              class="form-control"
              placeholder="Address"
              aria-label="Address"
              aria-describedby="basic-addressLines"
              rows="3"
              @keyup="changed"
            ></textarea>
            <span v-if="!v$.addressLines.required" class="text-danger">Address is required</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="input-group mb-3">
            <span class="input-group-text" id="basic-city">City:</span>
            <input v-model="form.city" class="form-control" placeholder="City" aria-label="City" aria-describedby="basic-city" @keyup="changed" />
            <span class="input-group-text" id="basic-stateprovince">State/Province:<span class="custom-astrisk">*</span></span>
            <select
              v-model="form.stateprovince"
              class="form-select"
              aria-label="State/Province"
              aria-describedby="basic-stateprovince"
              @change="changed"
            >
              <option v-for="item in lookups['StateProvince']" :key="item.id" :value="item.id">{{ item.name }}</option>
            </select>
            <span class="input-group-text" id="basic-postalcode">Postal Code:<span class="custom-astrisk">*</span></span>
            <input
              v-model="form.postalcode"
              class="form-control"
              placeholder="Postal Code"
              aria-label="Postal Code"
              aria-describedby="basic-postalcode"
              @keyup="changed"
            />
          </div>
          <span v-if="!v$.city.required" class="text-danger">City is required</span>
          <span v-if="!v$.stateprovince.required" class="text-danger">State/Province is required</span>
          <span v-if="!v$.postalcode.required" class="text-danger">Postal Code is required</span>
        </div>
      </div>
      <div class="row">
        <div class="col-2">
          <div class="input-group mb-3">
            <span class="input-group-text" id="basic-country">Country:<span class="custom-astrisk">*</span></span>
            <select v-model="form.country" class="form-select" aria-label="Country" aria-describedby="basic-country" @change="changed">
              <option v-for="item in lookups['Country']" :key="item.id" :value="item.id">{{ item.name }}</option>
            </select>
            <span v-if="!v$.country.required" class="text-danger">Country is required</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <span class="custom-required-label">* required</span>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { mapState } from 'pinia'
import { onboardStore } from '@/stores/onboard'
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
export default {
  name: 'OnboardAdditional',
  props: {
    companyId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      form: {
        type: 'additional',
        firm: null,
        company: '',
        addressLines: '',
        city: '',
        stateprovince: null,
        postalcode: '',
        country: null
      },
      isSave: false,
      rules: {
        company: { required },
        addressLines: { required },
        city: { required },
        stateprovince: { required },
        postalcode: { required },
        country: { required }
      },
      v$: null
    }
  },
  beforeMount() {
    this.isSave = false
    this.v$ = useVuelidate(this.rules, this.form)
  },
  emits: ['save'],
  computed: {
    ...mapState(onboardStore, ['lookups'])
  },
  methods: {
    updateData(data) {
      if (data !== undefined && data !== null) {
        this.form.firm = data.firm
      }
      this.isSave = false
      console.log('Updating Additional', this.form)
    },
    changed() {
      this.isSave = true
    },
    submitForm() {
      // this.save()
    },
    async save() {
      this.v$.$touch()
      if (this.v$.$invalid) {
        this.form.valid = false
      } else {
        this.form.valid = true
        if (this.companyId !== null) {
          this.form.companyId = parseInt(this.companyId)
        }
      }
      this.$emit('save', this.form)
      return this.form.valid
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-astrisk {
  position: relative;
  color: red;
  font-size: 0.8em;
  top: -5px;
  left: 5px;
}
.custom-required-label {
  font-size: 0.8em;
  color: red;
}
</style>
